<template>
  <section v-if="craft && craftCategories" class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Update Craft</p>
      <b-button type="is-danger" icon-left="delete" @click="deleteCraft"
        >Delete Craft</b-button
      >
    </header>

    <section class="modal-card-body">
      <div class="p-2">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <item-title
            :title="craft.name"
            :itemType="'craft'"
            :displaySuccess="false"
            @updateTitle="localCraft.name = $event"
          />

          <item-description
            :description="craft.description"
            @updateDescription="localCraft.description = $event"
          />

          <item-word
            :word="craft.starting_word"
            :wordPosition="'Starting'"
            :itemType="'craft'"
            @updateWord="localCraft.starting_word = $event"
          />

          <item-word
            :word="craft.ending_word"
            :wordPosition="'Ending'"
            :itemType="'craft'"
            @updateWord="localCraft.ending_word = $event"
          />

          <item-languages
            :languages="craft.language_list"
            :maxTags="'1'"
            @updateLanguages="localCraft.language_list = $event"
          />

          <item-progress
            :progress="craft.progress"
            :itemType="'craft'"
            @updateProgress="localCraft.progress = $event"
          />

          <b-field>
            <template slot="label">
              Category
              <b-tooltip
                position="is-right"
                type="is-dark"
                multilined
                size="is-small"
                label="Category of the Craft"
              >
                <b-icon
                  size="is-small"
                  type="is-gray"
                  icon="help-circle-outline"
                ></b-icon>
              </b-tooltip>
            </template>
            <b-select
              placeholder="Select a category"
              v-model="localCraft.craft_purchase_category_id"
            >
              <option
                v-for="category in craftCategories"
                :value="category.id"
                :key="category.id"
              >
                {{ category.attributes.name }}
              </option>
            </b-select>
          </b-field>

          <craft-skills
            :skill_ids="craft.skill_ids"
            @updateSkills="localCraft.skill_ids = $event"
          />
          <!-- <p class="pb-3">
            <span class="pb-2 has-text-weight-semibold is-size-6">Materials </span
            ><b-tooltip
              position="is-right"
              type="is-dark"
              multilined
              size="is-small"
              label="Materials used in the Craft"
            >
              <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </p>
          <b-field grouped>
            <b-field label="Amount" label-position="on-border" expanded>
              <b-field>
                <b-input placeholder="2 XL sheets" expanded></b-input>
              </b-field>
            </b-field>
            <b-field label="Material" label-position="on-border" expanded>
              <b-field>
                <b-input placeholder="Black Worbla" expanded></b-input>
              </b-field>
            </b-field>
            <b-field label="Store" label-position="on-border" expanded>
              <b-field>
                <b-input placeholder="Cosplay Shop" expanded></b-input>
              </b-field>
            </b-field>
            <p class="control">
              <b-button class="button is-success is-inverted"
                ><b-icon type="" icon="plus"
              /></b-button>
            </p>
          </b-field>

          <b-field grouped>
            <b-field label="Amount" label-position="on-border" expanded>
              <b-field>
                <b-input placeholder="2 XL sheets" expanded></b-input>
              </b-field>
            </b-field>
            <b-field label="Material" label-position="on-border" expanded>
              <b-field>
                <b-input placeholder="Black Worbla" expanded></b-input>
              </b-field>
            </b-field>
            <b-field label="Store" label-position="on-border" expanded>
              <b-field>
                <b-input placeholder="Cosplay Shop" expanded></b-input>
              </b-field>
            </b-field>
            <p class="control">
              <b-button class="button is-danger is-inverted"
                ><b-icon type="" icon="delete"
              /></b-button>
            </p>
          </b-field> -->

          <item-video :video="craft.video" @updateVideo="localCraft.video = $event" />

          <item-tags
            :tags="craft.tag_list"
            :placeholder="'WCS, Comic Con, Photoshop...'"
            @updateTags="localCraft.tag_list = $event"
          />

          <item-visibility
            :hidden="craft.hidden"
            :itemType="'craft'"
            @updateHidden="localCraft.hidden = $event"
          />
        </ValidationObserver>
      </div>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="$parent.close()">Close</b-button> </span
      ><span class="card-footer-item">
        <b-button type="is-success" @click="updateCraft">Update</b-button>
      </span>
    </footer>
  </section>
</template>

<script>
// Mixins
import { notificationMixin } from '@/mixins/notificationMixin'

// Components
import { ValidationObserver } from 'vee-validate'

// Attributes
import ItemTitle from '@/components/Attributes/ItemTitle'
import ItemDescription from '@/components/Attributes/ItemDescription'
import ItemLanguages from '@/components/Attributes/ItemLanguages'
import ItemProgress from '@/components/Attributes/ItemProgress'
import CraftSkills from '@/components/Attributes/CraftSkills'
import ItemVideo from '@/components/Attributes/ItemVideo'
import ItemTags from '@/components/Attributes/ItemTags'
import ItemVisibility from '@/components/Attributes/ItemVisibility'
import ItemWord from '@/components/Attributes/ItemWord'

export default {
  mixins: [notificationMixin],
  props: ['craft'],
  data () {
    return {
      localCraft: {
        name: null,
        description: null,
        progress: null,
        craft_purchase_category_id: null,
        tag_list: null,
        skill_ids: [],
        hidden: true,
        video: null,
        starting_word: null,
        ending_word: null,
        language_list: []
      },
      craftCategories: null,
      skills: [],
      skillsByCategory: []
    }
  },
  components: {
    ValidationObserver,
    ItemTitle,
    ItemDescription,
    ItemLanguages,
    ItemProgress,
    CraftSkills,
    ItemVideo,
    ItemTags,
    ItemVisibility,
    ItemWord
  },

  methods: {
    updateCraft () {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.$store
            .dispatch('crafts/update', { craft: this.craft.id, payload: this.localCraft })
            .then((resp) => {
              this.$emit('updatedCraft', resp.data.data.attributes)
              this.$parent.close()
            })
            .catch((error) => {
              // TODO: Handle
              console.log(error.response.data)
            })
        }
      })
    },
    deleteCraft () {
      this.$buefy.dialog.confirm({
        title: 'Deleting craft',
        message:
          'Are you sure you want to <b>delete</b> your craft? This action cannot be undone.',
        confirmText: 'Delete Craft',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store
            .dispatch('crafts/destroy', this.craft.id)
            .then((resp) => {
              this.$router.push(`/projects/${this.craft.project_id}`)
              this.$buefy.toast.open('Craft deleted!')
            })
            .catch((err) => {
              console.log(err)
              this.alertError()
            })
        }
      })
    }
  },
  created () {
    this.$store
      .dispatch('craftPurchaseCategories/index')
      .then((resp) => {
        this.craftCategories = resp.data.data
      })
      .catch((error) => {
        console.log(error)
        this.alertError()
      })
    this.localCraft.name = this.craft.name
    this.localCraft.description = this.craft.description
    this.localCraft.progress = this.craft.progress
    this.localCraft.craft_purchase_category_id = this.craft.craft_purchase_category.data.id
    this.localCraft.tag_list = this.craft.tag_list
    this.localCraft.hidden = this.craft.hidden
    this.localCraft.video = this.craft.video
    this.localCraft.starting_word = this.craft.starting_word
    this.localCraft.ending_word = this.craft.ending_word
    this.localCraft.skill_ids = [...this.craft.skills.map((e) => e.id)]
  }
}
</script>

<style lang="scss" scoped></style>
